import * as types from '../../types/actionTypes';

export const INIT_ACTIONS = new Set([types.INIT_OFFER, types.INIT_SUCCESS, types.OFFER_SAVE_SUCCESS]);
export const SYNC_RESET_ACTIONS = new Set([types.SYNC_MESSAGE, types.RESET_OFFER]);
export const INCENTIVE_ACTIONS = new Set([
    types.UPDATED_MANUAL_INCENTIVES,
    types.MODIFY_MANUAL_INCENTIVE,
    types.UPDATE_SELECTED_INCENTIVES,
    types.LOCATION_STANDARDS_RECONCILED,
    types.APPLIED_PROGRAM
]);
export const PAYMENT_ACTIONS = new Set([
    types.PAYMENT_RECEIVED,
    types.UPDATED_SECOND_PAYMENT_DUE_DATE_FIELD,
    types.UPDATED_SPECIAL_PAYMENT_FORMULA,
    types.UPDATED_PAYMENT_FREQUENCY,
    types.RESET_SPECIAL_PAYMENT_FORMULA,
    types.UPDATE_FLEX_BUY_PAYMENT,
    types.SET_PREVIOUS_FINANCE_INPUT_WITHOUT_FFB,
    types.RESET_PREVIOUS_FINANCE_INPUT_WITHOUT_FFB
]);
export const PRICE_UPDATE_ACTIONS = new Set([
    types.UPDATED_FINANCE_OFFER_PRICE,
    types.UPDATED_FINANCE_AND_LEASE_OFFER_PRICE,
    types.UPDATED_FINANCE_AND_CASH_OFFER_PRICE,
    types.UPDATED_FINANCE_AND_LEASE_AND_CASH_OFFER_PRICE,
    types.UPDATED_OFFER_PRICE_IMMEDIATE
]);
export const TAX_FEE_ACTIONS = new Set([
    types.UPDATE_PAYMENT_FEES_OVERRIDE,
    types.UPDATED_TOTAL_TAX_OVERRIDE,
    types.RESET_TAX_OVERRIDES,
    types.UPDATED_TOTAL_TAX_UPFRONT_OVERRIDE
]);
export const RATE_ACTIONS = new Set([
    types.TOGGLE_RATE_TYPE,
    types.UPDATED_SELL_RATE_OVERRIDE,
    types.UPDATED_SELL_RATE_FOR_SELECTED_TERM_UPQ,
    types.UPDATED_FINANCE_SELL_RATE_FOR_SELECTED_TERM_UPQ,
    types.UPDATED_BUY_RATE_FOR_SELECTED_TERM_UPQ,
    types.UPDATED_BUY_RATE_OVERRIDE
]);
export const RESIDUAL_ACTIONS = new Set([
    types.UPDATED_ADJUSTED_RESIDUAL_DOLLAR_OVERRIDE,
    types.UPDATED_ADJUSTED_RESIDUAL_PERCENT_OVERRIDE,
    types.UPDATED_BASE_RESIDUAL_DOLLAR_OVERRIDE,
    types.UPDATED_BASE_RESIDUAL_PERCENT_OVERRIDE,
    types.UPDATED_PROGRAM_RESIDUAL_DOLLAR_OVERRIDE,
    types.UPDATED_PROGRAM_RESIDUAL_PERCENT_OVERRIDE,
    types.REMOVED_PROGRAM_RESIDUAL_OVERRIDE,
    types.UPDATED_RESIDUAL_FOR_SELECTED_TERM_UPQ,
    types.UPDATE_RESIDUAL_TAB_DISPLAY_TYPE
]);
export const BALLOON_ACTIONS = new Set([
    types.UPDATED_BALLOON_PAYMENT_AMOUNT,
    types.UPDATED_BALLOON_TYPE,
    types.REVERT_BALLOON_DEAL_TO_BASE_FINANCE
]);
export const OVERRIDE_ACTIONS = new Set([
    types.UPDATED_RETAIL_PRICE_OVERRIDE,
    types.UPDATED_VEHICLE_INFO_DETAILS,
    types.UPDATED_SECURITY_DEPOSIT_OVERRIDE,
    types.UPDATED_MAX_RESIDUALIZED_MSRP_OVERRIDE,
    types.UPDATED_ACQFEE_UPFRONT_OVERRIDE,
    types.UPDATED_ACQFEE_OVERRIDE,
    types.UPDATED_RESERVE_SPLIT_OVERRIDE,
    types.CLEARED_RESERVE_SPLIT_LENDER_CHANGE_MESSAGE,
    types.UPDATED_MILEAGE_CHARGE_OVERRIDE,
    types.UPDATED_INCENTIVES_TOTAL_OVERRIDE,
    types.UPDATED_DOWN_PAYMENT_IMMEDIATE,
    types.UPDATED_CREDIT_DECISION_LENDER_NAME,
    types.UPDATED_CREDIT_DECISION_LENDER,
    types.UPDATE_CREDIT_DECISION_LENDER_WITH_ADDRESS,
    types.UPDATE_TITLING_LENDER_WITH_ADDRESS,
    types.UPDATED_CREDIT_DECISION_STATUS,
    types.UPDATE_DEAL_DEPOSIT,
    types.SET_OUTSIDE_LIENHOLDER,
    types.SET_TRANSFER_REGISTRATION_DETAILS,
    types.SET_PRIOR_LEASE_BALANCE,
    types.UPDATED_MANUAL_CREDIT_SCORE,
    types.SELECTED_ANNUAL_MILES,
    types.REQUEST_LEASE_CONTRACT_FIELDS,
    types.APPLY_ROLL_TO_OPTIONS,
    types.APPLY_DUE_AT_SIGNING,
    types.CLEAR_MANUAL_CREDIT_SCORE,
    types.SELECTED_CREDIT_TIER,
    types.UPDATED_TRADE_IN,
    types.UPDATE_OVERRIDES,
    types.SWITCH_VEHICLE,
    types.UPDATE_AVAILABLE_INCENTIVES,
    types.UPDATE_CASH_AVAILABLE_INCENTIVES,
    types.UPDATE_IS_TARGET_OUT_OF_POCKET,
    types.UPDATE_DEFERRED_DOWN_PAYMENT
]);
export const CREDIT_DECISION_ACTIONS = new Set([
    types.CREDIT_DECISION_APPROVED,
    types.APPLY_CREDIT_DECISION_DETAILS,
    types.UPDATED_CREDIT_DECISION_ENABLED,
    types.SET_PROGRAM_FALLBACK_OVERRIDES
]);
export const VEHICLE_TRADE_ACTIONS = new Set([
    types.APPLY_DEALER_DISCOUNTS,
    types.UPDATE_PROFITABILITY_DATA,
    types.SELECTED_TERM,
    types.CLEAR_OVERRIDES,
    types.CLEAR_OVERRIDES_WITHOUT_INCENTIVES,
    types.PARTIAL_RESET_OVERRIDES,
    types.LOCATION_RESET_OVERRIDES,
    types.PARTIAL_RESTORE_OVERRIDES,
    types.SELECTED_CREDIT_PARTIAL_RESET_OVERRIDES,
    types.HONOR_LEASE_MILEAGE_CHANGE,
    types.CHANGE_VEHICLE_UPDATE_OVERRIDES,
    types.FULL_RESET_OVERRIDES,
    types.RESTORE_OVERRIDES_FOR_FALLBACK,
    types.CLEAR_OVERRIDES_FALLBACK_SNAPSHOT,
    types.CAPTURE_OVERRIDES_FALLBACK_SNAPSHOT,
    types.APPLY_RECOMMENDED_VEHICLE_PAYMENT_DETAILS
]);
export const PAYMENT_GRID_ACTIONS = new Set([
    types.UPDATED_PAYMENT_GRID_TOGGLE,
    types.INITIALIZE_PAYMENT_GRID_FROM_TEMPLATE,
    types.INITIALIZE_PAYMENT_GRID_TERMS,
    types.INITIALIZE_PAYMENT_GRID_CASHDOWN,
    types.UPDATE_PAYMENT_GRID_TERM,
    types.UPDATE_PAYMENT_GRID_CASH_DOWN,
    types.RESET_PAYMENT_GRID,
    types.SET_PAYMENT_GRID_COLUMN_SOURCES,
    types.SET_PAYMENT_GRID_ORIGINAL_COLUMN_SOURCES,
    types.RESTORE_PAYMENT_GRID_TERM_OVERRIDES,
    types.SET_PAYMENT_GRID_CELL_PRICED_AT,
    types.SET_PAYMENT_GRID_PENDING_SELL_RATE,
    types.SET_PAYMENT_GRID_FALLBACK_RATES,
    types.SET_PAYMENT_GRID_LEFT_TERMS,
    types.SET_PAYMENT_GRID_USER_PRICED_TERM,
    types.SET_PAYMENT_GRID_COLUMN_CELLS,
    types.RESTORE_PAYMENT_GRID_ROW_QUOTES,
    types.SET_PAYMENT_GRID_ACTIVE_CELL,
    types.SET_PAYMENT_GRID_COLUMN_OVERRIDE,
    types.SET_PAYMENT_GRID_RESTORED_INPUTS,
    types.SET_PAYMENT_GRID_CARRIED_OVERRIDE,
    types.ADOPT_PAYMENT_GRID_CELL,
    types.SET_PAYMENT_GRID_DECIDED_COLUMNS,
    types.SET_PAYMENT_GRID_WRITTEN_TERM,
    types.CLEAR_PAYMENT_GRID_COLUMN_FIGURES,
    types.SET_PAYMENT_GRID_BUILD,
    types.SET_PAYMENT_GRID_DEAL_PROGRAM,
    types.SET_PAYMENT_GRID_DEAL_TERM_BEFORE_EDIT,
    types.HOLD_PAYMENT_GRID_FOR_VEHICLE_SWITCH,
    types.REBUILD_PAYMENT_GRID_AFTER_VEHICLE_SWITCH,
    types.TOGGLE_SHOULD_SHOW_PAYMENTS_GRID,
    types.TOGGLE_SHOULD_SHOW_PAYMENTS_GRID_FOR_TEMPLATE,
    types.SET_SHOULD_SAVE_MULTI_SCENARIO_PAYMENT_GRID,
    types.UPDATE_GRID_HEADERS_SNAPSHOT,
    types.PAYMENT_REQUESTED,
    types.PAYMENT_FAILURE,
    types.PAYMENT_ABORTED,
    types.PAYMENT_GRID_ROW_SUPERSEDED
]);
